import { HStack, VStack } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useAccountDetails } from '../../hooks'
import { AccountInformation } from '../AccountInformation'
import AccountFeatures from 'components/AccountFeaturesTable/AccountFeaturesTable'
import { AccountSearchBar } from 'components/AccountSearch'
import { AuthorizedTradersTable } from 'components/AuthorizedTradersTable'
import { InvestmentProfileTable } from 'components/InvestmentProfileTable'
import { DocumentsTable } from 'components/DocumentsTable'
import { EPreferencesTable } from 'components/EPreferencesTable'
import { AccountSummaryHeader } from 'components/AccountSummaryHeader'
import { InterestedPartiesTable } from 'components/InterestedPartiesTable'
import { AccountOwnersTable } from 'components/AccountOwnersTable'

interface MatchProps {
  accountNumber: string
}

export interface AccountDetailsPageProps
  extends RouteComponentProps<MatchProps> {}

//TODO AP placeholder, replace as necessary
const AccountDetailsPage = ({ match }: AccountDetailsPageProps) => {
  const {
    accountDetailsState: {
      accountDetails,
      loadingResult: loadingAccountDetails,
    },
    authorizedTradersState: { authorizedTraders, loadingAuthorizedTraders },
    accountOwnerState: { accountOwners, loadingAccountOwners },
    investmentProfileState: { investmentProfile, loadingInvestmentProfile },
    documentsState: { documents, loadingDocuments },
    ePreferencesState: { ePreferences, loadingEPreferences },
    marginsState: { margins, loadingMargins },
    marginCallsState: { marginCalls, loadingMarginCalls },
    amountAvailableState: { amountAvailable, loadingAmountAvailable },
    interestedPartiesState: { interestedParties, loadingInterestedParties },
    securemailState: { securemailLinks, loadingSecuremailLinks },
    getAccountDetails,
    getAccountNotes,
    getAccountOwners,
    getCorrespondent,
    getTradingRestrictions,
    getAuthorizedTraders,
    getInvestmentProfile,
    getDocuments,
    getEPreferences,
    getMargins,
    getMarginCalls,
    getAmountAvailable,
    getInterestedParties,
    getSecuremailLinks,
  } = useAccountDetails()

  useEffect(() => {
    getAccountDetails(match.params.accountNumber)
    getCorrespondent(match.params.accountNumber)
    getAccountOwners(match.params.accountNumber)
    getAccountNotes(match.params.accountNumber)
    getTradingRestrictions(match.params.accountNumber)
    getAuthorizedTraders(match.params.accountNumber)
    getInvestmentProfile(match.params.accountNumber)
    getDocuments(match.params.accountNumber)
    getEPreferences(match.params.accountNumber)
    getMargins(match.params.accountNumber)
    getMarginCalls(match.params.accountNumber)
    getAmountAvailable(match.params.accountNumber)
    getInterestedParties(match.params.accountNumber)
    getSecuremailLinks(match.params.accountNumber, 'STATEMENT')
    getSecuremailLinks(match.params.accountNumber, 'CONFIRM')
    getSecuremailLinks(match.params.accountNumber, 'TAX')
  }, [
    match.params.accountNumber,
    getAccountDetails,
    getAccountNotes,
    getCorrespondent,
    getAccountOwners,
    getTradingRestrictions,
    getAuthorizedTraders,
    getInvestmentProfile,
    getDocuments,
    getEPreferences,
    getMargins,
    getMarginCalls,
    getAmountAvailable,
    getInterestedParties,
    getSecuremailLinks,
  ])

  return (
    <VStack paddingBottom="5rem">
      <AccountSearchBar
        width="100%"
        accountNumber={match.params.accountNumber}
      />
      <AccountSummaryHeader
        accountNumber={match.params.accountNumber}
        pageTitle="DETAILS"
        accountDetails={accountDetails}
        margins={margins}
        marginCalls={marginCalls}
        amountAvailable={amountAvailable}
        isLoading={
          loadingAccountDetails ||
          loadingMargins ||
          loadingMarginCalls ||
          loadingAmountAvailable ||
          loadingSecuremailLinks
        }
        width="100%"
        documentsLinks={securemailLinks || {}}
      />
      <HStack
        paddingX="1rem"
        alignItems="flex-start"
        overflowY="scroll"
        width="100%"
      >
        <VStack width="60%">
          <AccountInformation width="100%" isSummary={false} />
          {!loadingAuthorizedTraders && (
            <AuthorizedTradersTable
              width="100%"
              paddingTop="2rem"
              authorizedTraders={authorizedTraders}
            />
          )}
          {!loadingInvestmentProfile && (
            <InvestmentProfileTable
              width="100%"
              paddingTop="2rem"
              investmentProfile={investmentProfile}
            />
          )}
        </VStack>
        <VStack paddingLeft="3rem" width="40%">
          {accountDetails && (
            <AccountFeatures accountDetails={accountDetails} width="100%" />
          )}
          {!loadingEPreferences && (
            <EPreferencesTable
              ePreferences={ePreferences}
              width="100%"
              paddingTop="2rem"
            />
          )}
          {!loadingAccountOwners && (
            <AccountOwnersTable
              accountOwners={accountOwners}
              width="100%"
              paddingTop="2rem"
            />
          )}
          {!loadingInterestedParties && (
            <InterestedPartiesTable interestedParties={interestedParties} />
          )}
          {!loadingDocuments && (
            <DocumentsTable
              documents={documents}
              width="100%"
              paddingTop="2rem"
            />
          )}
        </VStack>
      </HStack>
    </VStack>
  )
}

export default AccountDetailsPage
